import { auth } from "./api"
import { dev } from "./util"

const console = window.console
const levels = ['trace', 'debug', 'log', 'info', 'warn', 'error']
const messages = [...levels, 'dir', 'dirxml', 'table', 'assert']
// Only message methods are muted. Native APIs such as createTask and memory
// keep their values and return contracts for framework and browser consumers.
const save = Object.fromEntries(messages.filter(method => typeof console[method] === 'function')
  .map(method => [method, console[method]]))
const stamped = { ...save }, silent = {}
let prev = Date.now()
for (const method of Object.keys(save)) silent[method] = () => undefined
for (const method of levels.filter(method => method in save)) {
  stamped[method] = (...args) => {
    const now = Date.now(), elapsed = now - prev
    save[method].call(console, `${elapsed > 9_999 ? '>9999' : (' '+elapsed).padStart(5)}ms`, ...args)
    prev = now
  }
}

export default console
window.console['_dev'] = () => Object.assign(window.console, save)
window.console['_stamped'] = () => Object.assign(window.console, stamped)
window.console['_silent'] = () => Object.assign(window.console, silent)

if (dev) window.console['_dev']()
else window.console['_silent']()
console.debug('DEV', dev)

setTimeout(() => {
  auth.add(() => {
    if (auth.user === 'cyrus') window.console['_dev']()
  }, true)
})
